import React, { useState, useRef, useEffect } from 'react';
import Header from './Header';
import Topsection from './Topsection';
import Footer from './Footer';
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';
import HiringPartnersFeedback from './HiringPartnersFeedback';

import { Helmet } from 'react-helmet';

const Recruiters = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const modalRef = useRef(null);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
      name: '',
      company: '',
      email: '',
      contact: '',
      designation: '',
  });
  

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required.';
    } else if (!/^[A-Za-z ]+$/.test(formData.name.trim())) {
      newErrors.name = 'Name can contain only letters and spaces.';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters.';
    }

    if (!formData.company.trim()) newErrors.company = "Company name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.contact.trim()) {
      newErrors.contact = "Phone number is required";
    } else if (formData.contact.length < 10) {
      newErrors.contact = "Phone number must be at least 10 digits";
    }

    if (!formData.designation.trim()) newErrors.designation = "Designation is required";

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      // const response = await fetch('http://localhost:5002/api/recruiters', {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/recruiters`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData }),
      });

      const result = await response.json();

      if (response.ok) {
        alert('Form submitted!');
        setFormData({ name: '', company: '', email: '', contact: '', designation: '' });
      } else {
        alert(result.error || 'Failed to submit form');
      }
    } catch (err) {
      console.error(err);
      alert('Error submitting form');
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
    setTimeout(() => setModalVisible(true), 10);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setTimeout(() => setShowModal(false), 300);
  };

  // Detect click outside modal content
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    if (showModal) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showModal]);

  return (
    <>
    <Helmet>
            <title>Fortune Cloud Technologies | For Recruiters</title>
            <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
            <meta name="robots" content="index, follow" />
    </Helmet>
    <div className='gradientbgcolor2'>
      <Topsection />
      <Header />

      <section className="container mt-5 myfont1 text-white">
        <div className="row align-items-center">
          <div className="col-md-8 mb-4 mb-md-0 animate__animated animate__slow animate__fadeInDown">
            <h1 className="fw-bold mb-4">Hire Skilled Talent, Quickly.</h1>
            <p className="lead">
              Choose from a curated pool of trained and vetted professionals. Boost your success rate from interview to offer.
            </p>
            <p className="text-white">
              <strong>Experienced Hires</strong> | <strong>Off-Campus Recruitment</strong> | <strong>Campus Drives</strong>
            </p>
          </div>

          <div className="col-md-4 mb-5 d-flex justify-content-center align-items-center flex-column animate__animated animate__slow animate__fadeInDown">
            <ul className="list-unstyled text-start">
              <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>5000+</strong> Trained Students</li>
              <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Zero</strong> Hiring Cost</li>
              <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>2,000+</strong> Client Companies</li>
            </ul>

            <button
              type="button"
              className="btn brcolor_and_txcolor1 rounded-0 fw-bold mt-3"
              onClick={handleOpenModal}
            >
              Schedule a Call
            </button>
          </div>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div
          className={`modal fade myfont1 ${modalVisible ? 'show d-block' : 'd-block'}`}
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            transition: 'opacity 0.3s ease',
            opacity: modalVisible ? 1 : 0,
          }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content text-dark" ref={modalRef}>
              <div className="modal-header d-flex justify-content-between align-items-start text-start">
                <div>
                  <h4 className="modal-title myfont1 fw-bold mb-1">Schedule a Call</h4>
                  <p className="mb-0"><span className='text-danger'>*</span>Please fill in your details and we’ll get back to you shortly.</p>
                </div>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="modal-body">
                  <input
  type="text"
  className={`form-control mb-2 rounded-0 ${errors.name ? 'is-invalid' : ''}`}
  placeholder="Your Full Name"
  name="name"
  value={formData.name}
  onChange={handleChange}
/>
{errors.name && <div className="invalid-feedback">{errors.name}</div>}

<input
  type="text"
  className={`form-control mb-2 rounded-0 ${errors.company ? 'is-invalid' : ''}`}
  placeholder="Company Name"
  name="company"
  value={formData.company}
  onChange={handleChange}
/>
{errors.company && <div className="invalid-feedback">{errors.company}</div>}

<input
  type="email"
  className={`form-control mb-2 rounded-0 ${errors.email ? 'is-invalid' : ''}`}
  placeholder="Company Email"
  name="email"
  value={formData.email}
  onChange={handleChange}
/>
{errors.email && <div className="invalid-feedback">{errors.email}</div>}

<input
  type="tel"
  className={`form-control mb-2 rounded-0 ${errors.contact ? 'is-invalid' : ''}`}
  placeholder="Phone Number"
  name="contact"
  value={formData.contact}
  onChange={handleChange}
/>
{errors.contact && <div className="invalid-feedback">{errors.contact}</div>}

<input
  type="text"
  className={`form-control mb-2 rounded-0 ${errors.designation ? 'is-invalid' : ''}`}
  placeholder="Designation"
  name="designation"
  value={formData.designation}
  onChange={handleChange}
/>
{errors.designation && <div className="invalid-feedback">{errors.designation}</div>}

                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary rounded-0" onClick={handleCloseModal}>
                    Close
                  </button>
                  <button  type="button" onClick={handleSubmit} className="btn btn-primary rounded-0">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      </div>

      <div className='container myfont1 my-4 animate__animated animate__slow animate__fadeInDown'>
        <h2 className='fw-bold'>Fortune Cloud<br/> Your gateway to top-tier talent</h2>

        <div className='row my-4'>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r1.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Industry-Ready Talent</h4>
              <p>Our students are trained with hands-on projects and real-world tools, making them job-ready from day one.</p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r2.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Focused on Emerging Technologies</h4>
              <p>We specialize in cloud computing, DevOps, web development, and other in-demand technologies that align with today’s business needs.</p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r3.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Customizable Skill Sets</h4>
              <p>Students are trained with flexible curricula, allowing them to specialize in the skills your company values most.</p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r4.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Practical Learning Approach</h4>
              <p>With a focus on live projects, internships, and capstone tasks, our students gain experience that goes beyond textbooks.</p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r5.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Strong Work Ethic & Discipline</h4>
              <p>We instill a culture of professionalism, responsibility, and continuous learning in all our learners.</p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='p-2 my-2'>
              <img src="/assets/images/icons/r6.png" alt="Logo" width="100" class="img-fluid" />
              <h4 className="modal-title myfont1 fw-bold my-2">Pre-screened for Quality</h4>
              <p>Only the most committed and capable students graduate from our institute, ensuring a high level of competence.</p>
            </div>
          </div>
        </div>
      </div>

      {/* <HiringPartnersFeedback/> */}

      <Footer />
      <FloatingButton />
      <Mobilefooterbtn />
    
    </>
  );
};

export default Recruiters;
